namespace Nobox.Chat {
    export namespace PermissionKeys {
        export const General = "Chat:General";

        namespace ChatDivision {
            export const Delete = "ChatDivision:Delete";
            export const Modify = "ChatDivision:Modify";
            export const View = "ChatDivision:View";
        }

        namespace ChatArchive {
            export const Delete = "ChatArchive:Delete";
            export const Modify = "ChatArchive:Modify";
            export const View = "ChatArchive:View";
        }

        namespace ChatCompany {
            export const Delete = "ChatCompany:Delete";
            export const Modify = "ChatCompany:Modify";
            export const View = "ChatCompany:View";
        }

        namespace ChatFunnel {
            export const Delete = "ChatFunnel:Delete";
            export const Modify = "ChatFunnel:Modify";
            export const View = "ChatFunnel:View";
        }

        namespace ChatLink {
            export const Delete = "ChatLink:Delete";
            export const Modify = "ChatLink:Modify";
            export const View = "ChatLink:View";
        }

        namespace ChatMessage {
            export const Delete = "ChatMessage:Delete";
            export const Modify = "ChatMessage:Modify";
            export const View = "ChatMessage:View";
        }

        namespace ChatNote {
            export const Delete = "ChatNote:Delete";
            export const Modify = "ChatNote:Modify";
            export const View = "ChatNote:View";
        }

        namespace ChatRoom {
            export const Delete = "ChatRoom:Delete";
            export const Modify = "ChatRoom:Modify";
            export const View = "ChatRoom:View";
        }

        namespace ChatTags {
            export const Delete = "ChatTags:Delete";
            export const Modify = "ChatTags:Modify";
            export const View = "ChatTags:View";
        }

        namespace ChatTemplate {
            export const Delete = "ChatTemplate:Delete";
            export const Modify = "ChatTemplate:Modify";
            export const View = "ChatTemplate:View";
            export const Page = "ChatTemplate:Page";
        }

        namespace ChatReport {
            export const Page = "ChatReport:Page";
        }
    }
}
